const DEV_TEST_CLIENT_ID = "7ju28rXq1PGcIxw3GuPiNE2x7X3M2I16";
const STAGING_TEST_CLIENT_ID = "7ju28rXq1PGcIxw3GuPiNE2x7X3M2I16";
const PRE_PROD_TEST_CLIENT_ID = "n8Yl2U1wiDDSvD1mDAUjzEekSddNeUzh";
const PROD_TEST_CLIENT_ID = "8BFKGrQpbVOXlTGv7b3bXRL7UJEemIAt";

export const getSafeModeHeaders = (featureKeys) => {
    const isSafeModeFeatureEnabled = featureKeys && featureKeys["NetApp.TenancyV4/safemode"]?.active;
    return isSafeModeFeatureEnabled ? {
        headers: {
            'Accept': 'application/vnd.netapp.bxp.user.safemode+json'
        }
    } : {};
}

export const getTestClientId = (environment) => {
    switch (environment) {
        case 'dev':
            return DEV_TEST_CLIENT_ID;
        case 'staging':
            return STAGING_TEST_CLIENT_ID;
        case 'preprod':
            return PRE_PROD_TEST_CLIENT_ID;
        default:
            return PROD_TEST_CLIENT_ID;
    }
}

/**
 * Decodes a base64url-encoded string to a regular string.
 * Handles URL-safe characters and padding required for standard base64 decoding.
 * 
 * @param {string} str - The base64url-encoded string to decode
 * @returns {string} The decoded string
 */
export const base64UrlDecode = (str) => {
    // Replace URL-safe characters
    str = str.replace(/-/g, '+').replace(/_/g, '/');
    // Pad with '='
    while (str.length % 4) {
        str += '=';
    }
    // Decode
    return atob(str);
}

export const isNcl = () => {
    return process.env.REACT_APP_IS_NCL === "true";
}

export const isSM3 = () => {
    return process.env.REACT_APP_IS_SM3 === "true"
}